import PropTypes from 'prop-types';
import ContentPanel from 'components/ui-components/ContentPanel';
import AddressLines from 'components/ui-components/AddressLines';

const CompanyDataPanel = ({ companyName, address, resetCompanyData }) => (
  <ContentPanel
    cta={{
      title: 'Change company',
      onClick: () => resetCompanyData(),
    }}>
    {companyName && (
      <>
        <h4 className="mt-0 mb-3 fs-16 tc-main">Company Name</h4>
        <p className="mb-0 fs-16 tc-secondary fw-400">{companyName}</p>
      </>
    )}

    {address && (
      <>
        <h4 className="mb-3 fs-16 tc-main">Registered Office Address</h4>
        <p className="mb-0 fs-16 tc-secondary fw-400">
          <AddressLines address={address} />
        </p>
      </>
    )}
  </ContentPanel>
);

CompanyDataPanel.propTypes = {
  companyName: PropTypes.string,
  address: PropTypes.object,
  resetCompanyData: PropTypes.func,
};

export default CompanyDataPanel;
